import type React from "react"
import { Loading } from "./loading"

const LoadingFallback: React.FC = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loading size={32} text="Loading..." />
    </div>
  )
}

export default LoadingFallback
